





































































import { Vue, Component } from 'vue-property-decorator';
import { getWorkDetail, getPV } from '../api/index';
import { Popup } from 'vant';
Vue.use(Popup);
@Component
export default class SharePage extends Vue {
  pointOut = false;
  item: any = {};
  PV = 0;
  get id() {
    return this.$route.query.id;
  }
  async created() {
    await this.fetchDetail();
    this.fetchPV();

    // 分享
    setTimeout(() => {
      this.$appShareInfo({
        title: '重庆艺术大市场·开放的六月 2020四川美术学院云端艺术游',
        url: window.location.href,
        subtitle:
          '我是参观者，邀您一起参加重庆艺术大市场·开放的六月 2020四川美术学院云端艺术游',
        classId: -1,
        id: -1,
        image: this.item.pictures[0],
        type: 3,
      });
    }, 500);
    this.$wxShareInfo({
      title: '重庆艺术大市场·开放的六月 2020四川美术学院云端艺术游',
      subtitle:
        '我是参观者，邀您一起参加重庆艺术大市场·开放的六月 2020四川美术学院云端艺术游',
      image: this.item.pictures[0],
    });
  }
  async fetchDetail() {
    const ret = await getWorkDetail(this.id as string);
    this.item = ret.data;
  }
  async fetchPV() {
    const ret = await getPV();
    this.PV = ret.data;
  }
  // 返回
  backRoute() {
    console.log(window.history);
    if (window.history.length <= 1) {
      this.$router.push('index');
    } else {
      this.$router.go(-1);
    }
  }
}
